import { useEffect, useState } from 'react';

import { formatRelativeFor } from '../utils/formatters';

const REFRESH_MS = 10000;

// Live "time ago / from now" text for an input suffix. Re-renders on an
// interval so second/minute-scale values don't go stale while the form is
// open. Returns '' when disabled or the value is blank/invalid.
// `compact` swaps in the short form ("3m ago", "in 4h") for phone-width
// inputs, where the long words would push the typed value out of view.
// `dataType` 'date' reads in whole days ("today", "3 days ago") — a date has
// no clock to count hours from; anything else reads as an instant.
export default function useRelativeTime( value, { enabled = true, compact = false, dataType = 'date-time' } = {} ) {

	const [ , setTick ] = useState( 0 );

	useEffect( () => {
		if ( ! enabled || ! value ) return undefined;
		const id = setInterval( () => setTick( tick => tick + 1 ), REFRESH_MS );
		return () => clearInterval( id );
	}, [enabled, value] );

	if ( ! enabled ) return '';
	return formatRelativeFor( value, dataType, { compact } );

}
